module.exports = __webpack_public_path__ + "img/falcon-coin.362c0817.png";